module.exports = __webpack_public_path__ + "assets/img/icon4.a243e35e.svg";